var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnUnfoldComments = function SvgIcnUnfoldComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 4.194 2.55 2.473.783-.761L8 2.666l-3.333 3.24.783.76L8 4.195ZM8 11.806 5.45 9.333l-.784.761L8 13.335l3.333-3.24-.783-.76L8 11.805Z",
    fill: "#292525"
  })));
};
export default SvgIcnUnfoldComments;